<template>
  <material-card-custom
    :size.sync="internalSize"
    :height.sync="internalHeight"
    :order.sync="internalOrder"
    :maxOrderValue="maxOrderValue"
    :widgetId="widgetId"
    @remove-widget="$emit('remove-widget', $event)"
    @add-widget="$emit('add-widget', $event)"
    color="primary"
    :title="
      $t('components.vue_material_dashboard.items.faq_dashboard_item.title')
    "
  >
    <router-link :to="{ name: 'faq' }" class="text-decoration-none">
      <v-card-text class="text-left pb-0">
        <v-list class="pt-0">
          <v-list-item-group v-model="selectedItem">
            <v-list-item v-if="loading">
              <v-row justify="center">
                <v-progress-circular
                  size="50"
                  class="mt-10"
                  indeterminate
                ></v-progress-circular>
              </v-row>
            </v-list-item>
            <div v-show="!loading && topFaqs.length !== 0">
              <v-list-item class="px-0" @click.prevent="openFaq(topFaqs[0])">
                <v-list-item-icon class="my-auto text-left">
                  <v-col>
                    <v-icon size="80">mdi-help-circle-outline</v-icon>
                  </v-col>
                </v-list-item-icon>
                <v-list-item-content class="py-0">
                  <v-col
                    class="text-subtitle-1 font-weight-bold"
                    v-html="
                      $vuetify.lang.current === 'en'
                        ? topFaqs[0].QuestionEN
                        : topFaqs[0].QuestionFR
                    "
                  >
                  </v-col>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <template v-for="i in 3">
                <v-list-item
                  class="px-0"
                  :key="i"
                  @click.prevent="openFaq(topFaqs[i])"
                >
                  <v-list-item-icon class="my-auto">
                    <v-icon size="50" color="primary">mdi-help-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content class="py-1">
                    <v-col
                      :class="`
                      text-subtitle-2 text-lg-subtitle-1
                      font-weight-bold
                      py-2`"
                      v-html="
                        topFaqs[i]
                          ? $vuetify.lang.current === 'en'
                            ? topFaqs[i].QuestionEN
                            : topFaqs[i].QuestionFR
                          : ''
                      "
                    >
                    </v-col>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="i + '-divider'"></v-divider>
              </template>
            </div>
            <div v-show="!loading && topFaqs.length === 0">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-col class="text-subtitle-2 text-left">
                    {{
                      $t(
                        "components.vue_material_dashboard.items.faq_dashboard_item.no_faqs"
                      )
                    }}
                  </v-col>
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list-item-group>
        </v-list>
      </v-card-text>
    </router-link>
    <v-row no-gutters class="bottom-btn">
      <v-btn class="secondary lighten-2" width="150px" :to="{ name: 'faq' }">{{
        $t("components.vue_material_dashboard.items.faq_dashboard_item.more")
      }}</v-btn>
    </v-row>
  </material-card-custom>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MaterialCardCustom from "@/components/VueMaterialDashboard/material/MaterialCardCustomDashboard.vue";

const GENERAL_INFORMATION_GROUP = "General Information";
const TOP_FAQ_COUNT = 4;

export default {
  components: {
    MaterialCardCustom,
  },
  props: {
    widgetId: String,
    size: Number,
    order: Number,
    height: Number,
    maxOrderValue: Number,
  },
  data() {
    return {
      internalSize: undefined,
      internalHeight: undefined,
      internalOrder: undefined,
      selectedItem: undefined,
      faqData: [],
      loading: false,
      error: undefined,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", ["userProfile", "isPensionsPortal"]),
    memberTypeKeyword() {
      return this.isPensionsPortal
        ? this.userProfile?.AccountStatus
        : this.userProfile?.MemberGroup?.Name;
    },
    topFaqs() {
      return this.faqData
        .filter(
          (i) =>
            i.GroupEN === GENERAL_INFORMATION_GROUP &&
            i.MemberTypes &&
            (i.MemberTypes.includes(this.memberTypeKeyword) ||
              i.MemberTypes.includes("All"))
        )
        .slice(0, TOP_FAQ_COUNT);
    },
  },
  watch: {
    size: {
      handler(v) {
        this.internalSize = v;
      },
    },
    internalSize: {
      handler(v) {
        this.$emit("update:size", v);
      },
    },
    height: {
      handler(v) {
        this.internalSize = v;
      },
    },
    internalHeight: {
      handler(v) {
        this.$emit("update:height", v);
      },
    },
    order: {
      handler(v) {
        this.internalOrder = v;
      },
    },
    internalOrder: {
      handler(v) {
        this.$emit("update-order", v);
      },
    },
  },
  mounted() {
    if (this.size !== null && this.size !== undefined) {
      this.internalSize = this.size;
    }
    if (this.height !== null && this.height !== undefined) {
      this.internalHeight = this.height;
    }
    if (this.order !== null && this.order !== undefined) {
      this.internalOrder = this.order;
    }
    this.loadData();
  },
  methods: {
    ...mapActions("common", ["getFaqData"]),
    async loadData() {
      try {
        this.loading = true;
        this.faqData = (
          await this.getFaqData({
            planIdentityId: this.user.plan,
          })
        ).data;
      } catch (error) {
        this.error = error;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    openFaq(item) {
      this.$router.push({
        name: "faq",
        params: {
          faq: item,
        },
      });
    },
  },
};
</script>
<style scoped>
.bottom-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
</style>
